import { useEffect, useState } from 'react';
import { Dashboard } from '@dashboard/infrastructure/ui/view/dashboard';
import { UsersView } from 'users/infrastructure/ui/view/users';
import { historyRepository } from '@shared/domain/router/router.repository';
import { ROUTES } from '@shared/infrastructure/router/paths';
import { WithAuthentication } from '@main/infrastructure/controllers/withAuthentication/withAuthentication';
import { TherapiesView } from 'therapy/infrastructure/ui/view/therapy';
import { TopicView } from '@topic/infrastructure/topic';
import { SubtopicView } from 'subtopic/subtopic';
import { SubtopicEdit } from 'subtopic/subtopicEdit';
import { SubtopicCreate } from 'subtopic/subtopicCreate';
import { routeRepository } from '@shared/domain/router/route/route.repository';
import { TopicEdit } from '@topic/infrastructure/topicEdit';
import { TopicCreate } from '@topic/infrastructure/topicCreate';
import { ContentView } from 'content/content';
import { ContentEdit } from 'content/contentEdit';
import { ContentCreate } from 'content/contentCreate';
import { SnapshotView } from 'snapshot/snapshot';

let history = historyRepository.browserRouter;

export const RoutesRenderer = () => {
  const [pathname, setpath] = useState(history.location.pathname);
  useEffect(() => {
    let unlisten = history.listen(({ location }) => {
      setpath(location.pathname);
    });
    return () => unlisten();
  }, []);

  if (pathname === ROUTES.DASHBOARD.path) return <Dashboard></Dashboard>;
  else if (pathname === ROUTES.THERAPIES.path)
    return (
      <WithAuthentication>
        <TherapiesView></TherapiesView>
      </WithAuthentication>
    );
  else if (pathname === ROUTES.TOPICS.path)
    return (
      <WithAuthentication>
        <TopicView></TopicView>
      </WithAuthentication>
    );
  else if (pathname === ROUTES.SUBTOPICS.path)
    return (
      <WithAuthentication>
        <SubtopicView></SubtopicView>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.SUBTOPICS_FILTERED.path, pathname)
  )
    return (
      <WithAuthentication>
        <SubtopicView></SubtopicView>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.SUBTOPICS_CREATE.path, pathname)
  )
    return (
      <WithAuthentication>
        <SubtopicCreate></SubtopicCreate>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.SUBTOPICS_EDIT.path, pathname)
  )
    return (
      <WithAuthentication>
        <SubtopicEdit></SubtopicEdit>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.TOPICS_CREATE.path, pathname)
  )
    return (
      <WithAuthentication>
        <TopicCreate></TopicCreate>
      </WithAuthentication>
    );
  else if (routeRepository.shouldMatchRoute(ROUTES.TOPICS_EDIT.path, pathname))
    return (
      <WithAuthentication>
        <TopicEdit></TopicEdit>
      </WithAuthentication>
    );
  else if (pathname === ROUTES.USERS.path)
    return (
      <WithAuthentication>
        <UsersView></UsersView>
      </WithAuthentication>
    );
  else if (pathname === ROUTES.CONTENTS.path)
    return (
      <WithAuthentication>
        <ContentView></ContentView>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.CONTENTS_CREATE.path, pathname)
  )
    return (
      <WithAuthentication>
        <ContentCreate></ContentCreate>
      </WithAuthentication>
    );
  else if (
    routeRepository.shouldMatchRoute(ROUTES.CONTENTS_EDIT.path, pathname)
  )
    return (
      <WithAuthentication>
        <ContentEdit></ContentEdit>
      </WithAuthentication>
    );
  else if (pathname === ROUTES.SNAPSHOTS.path)
    return (
      <WithAuthentication>
        <SnapshotView></SnapshotView>
      </WithAuthentication>
    );
  return null;
};
